<script lang="ts">
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import type { HardwareMarqueeProps } from './types';

  export let entryId: HardwareMarqueeProps['entryId'];
  export let customCssClass: HardwareMarqueeProps['customCssClass'];
  export let content: HardwareMarqueeProps['content'];

  const scrollSpeed = 140;
  let containerWidth: number;

  $: duration = containerWidth / scrollSpeed;
</script>

<div
  class="HardwareMarquee HardwareMarquee-{entryId}-box-properties {customCssClass}"
  data-entry-id={entryId}
  style="--marquee-duration: {duration}s;"
>
  <div class="HardwareMarquee__container" bind:clientWidth={containerWidth}>
    {#each Array.from({ length: 10 }) as _}
      <DynamicChildrenComponent children={[content]} />
    {/each}
  </div>
</div>

<style lang="scss">
  @layer custom-components {
    .HardwareMarquee {
      --marquee-padding: calc(var(--space-30) / 2);

      padding: {
        top: var(--marquee-padding);
        bottom: var(--marquee-padding);
      }

      white-space: nowrap;
      overflow: hidden;

      &:hover {
        .HardwareMarquee__container {
          animation-play-state: paused;
        }
      }

      &__container {
        will-change: transform;
        animation: marquee var(--marquee-duration) linear infinite;
      }

      &.sq-custom-evenly-spaced {
        :global {
          .RichTextFieldComponent {
            --font-size: var(--font-size-body-small);
            --line-height: var(--line-height-body-small);
            & > p {
              padding-right: var(--space-10);
              padding-left: var(--space-10);
              color: var(--color-white);
              &:after {
                content: ' → ';
                display: inline;
                margin-left: var(--space-10);
                font-weight: var(--font-weight-medium, 500);
              }
            }
          }
        }
      }

      &.sq-custom-blue-theme-bg {
        background-color: var(--color-blue);
      }

      :global {
        .RichTextFieldComponent {
          --font-size: var(--font-size-body-extra-small);
          --line-height: var(--line-height-body-extra-small);

          display: inline-block;

          & > p {
            padding: {
              right: var(--marquee-padding);
              left: var(--marquee-padding);
            }
          }
        }
      }
    }

    @keyframes marquee {
      0% {
        transform: translateX(0%);
      }

      100% {
        transform: translateX(-50%);
      }
    }
  }
</style>
